<template>
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="194" height="194" viewBox="0 0 194 194">
        <defs>
            <filter id="Ellipse_49" x="0" y="0" width="194" height="194" filterUnits="userSpaceOnUse">
                <feOffset input="SourceAlpha"/>
                <feGaussianBlur stdDeviation="7.5" result="blur"/>
                <feFlood flood-opacity="0.161"/>
                <feComposite operator="in" in2="blur"/>
                <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g id="Group_2044" data-name="Group 2044" transform="translate(22.141 22.5)">
            <g transform="matrix(1, 0, 0, 1, -22.14, -22.5)" filter="url(#Ellipse_49)">
                <circle id="Ellipse_49-2" data-name="Ellipse 49" cx="74.5" cy="74.5" r="74.5" transform="translate(22.5 22.5)" fill="#827da9"/>
            </g>
            <g id="Group_2037" data-name="Group 2037" transform="translate(32.77 32.484)">
                <g id="Group_2035" data-name="Group 2035" transform="translate(0)">
                    <path id="Path_617" data-name="Path 617" d="M754.982,198.095a41.545,41.545,0,1,1-41.547,41.547,41.547,41.547,0,0,1,41.547-41.547Z" transform="translate(-713.435 -198.095)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    <line id="Line_14" data-name="Line 14" x1="19.989" y2="19.989" transform="translate(45.328 18.714)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    <line id="Line_15" data-name="Line 15" x1="15.467" y1="8.93" transform="translate(22.107 30.864)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    <path id="Path_618" data-name="Path 618" d="M732.616,212.586a4.69,4.69,0,1,0,4.69,4.69,4.688,4.688,0,0,0-4.69-4.69Z" transform="translate(-691.069 -175.729)" fill="none" stroke="#fff" stroke-width="3"/>
                    <line id="Line_16" data-name="Line 16" y2="2.923" transform="translate(41.546 9.985)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    <line id="Line_17" data-name="Line 17" x2="2.923" transform="translate(9.985 41.546)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    <line id="Line_18" data-name="Line 18" y1="2.923" transform="translate(41.546 70.184)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                    <line id="Line_19" data-name="Line 19" x1="2.923" transform="translate(70.184 41.546)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                </g>
            </g>
        </g>
    </svg>




</template>

<script>
export default {
    name: "svg-location"
}
</script>

<style scoped lang="scss">
svg {
    transition: 200ms all ease-in-out;
    &:hover {
        transform: scale(1.1);
    }
}
</style>
